import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/shared/store';

type Permission = {
  id: number | null;
  permission_name: string;
  description: string;
  permission_code: string;
  is_enabled: boolean;
};

type PermissionState = {
  permission: Permission;
  deletePermissionId: number | null;
};

const initialState: PermissionState = {
  permission: {
    id: null,
    permission_name: '',
    description: '',
    permission_code: '',
    is_enabled: true,
  },
  deletePermissionId: null,
};

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    // ---- Permission setters ----
    setPermission(state, action: PayloadAction<Permission>) {
      state.permission = action.payload;
    },

    clearPermission(state) {
      state.permission = initialState.permission;
    },

    // ---- Delete setters ----
    setDeletePermissionId(state, action: PayloadAction<number>) {
      state.deletePermissionId = action.payload;
    },

    clearDeletePermissionId(state) {
      state.deletePermissionId = null;
    },
  },
});

export const {
  setPermission,
  clearPermission,
  setDeletePermissionId,
  clearDeletePermissionId,
} = permissionSlice.actions;

export const selectPermission = (state: RootState) =>
  state.permission.permission;

export const selectDeletePermissionId = (state: RootState) =>
  state.permission.deletePermissionId;

export default permissionSlice.reducer;
